<template>
    <div
        class="
            group
            mx-1
            mb-2
            px-4
            py-2
            rounded-full
            text-xs text-secondary-light
            font-medium
            tracking-wide
            cursor-pointer
            hover:bg-primary hover:text-white
            transition-all
            duration-500
        "
        :class="color"
    >
        {{ label }}
        <span
            class="
                text-primary
                group-hover:text-white
                transition-all
                duration-500
            "
        >
            <i class="icon-np-cancel"></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: "bg-gray-100",
        },
    },
};
</script>
